// extracted by mini-css-extract-plugin
export default {"root":"quoted-tweet-container_root__bP26T","article":"quoted-tweet-container_article__4Ch-O"};